/** @domain trading -- Trading compliance fields: blackout periods, pre-clearance, eligibility. */
import { z } from 'zod';
import { createDomainField } from './types';

const define = createDomainField('trading');

export const blackoutTitle = define({
  label: 'Blackout Title',
  placeholder: 'Enter blackout title',
  schema: z
    .string()
    .max(200, 'Must be at most 200 characters')
    .regex(/^\s*\S[\s\S]*$/, 'Must not be blank'),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const blackoutEligibilityId = define({
  label: 'Participant Selection Method',
  schema: z.string(),
  adapterHint: 'select',
  displayFormat: 'text',
});

export const startImmediately = define({
  label: 'Start Immediately',
  schema: z.boolean(),
  adapterHint: 'checkbox',
  displayFormat: 'boolean',
});

export const tradePreclearanceRequired = define({
  label: 'Trade Pre-Clearance',
  schema: z.boolean(),
  adapterHint: 'checkbox',
  displayFormat: 'boolean',
});
